<template>
  <li class="tile" :class="dynamicClasses">
    <div class="tile__group">
      <div class="tile__heading">{{ heading }}</div>
      <div class="tile__body">{{ body }}</div>
    </div>
  </li>
</template>

<script lang="ts">
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';

const DEFAULT_HEADING = 'Send a request';
const DEFAULT_BODY = 'Request your own time';

export default {
  name: 'AvailabilityCard',
  props: ['availability'],
  computed: {
    dynamicClasses(): string {
      if (this.availability.node.kind) {
        return `tile--${this.availability.node.kind.toLowerCase()}`;
      }

      return 'tile--default';
    },
    heading(): string {
      const title = format(new Date(this.availability.node.start), 'E, MMM d') || DEFAULT_HEADING;
      return title;
    },
    body(): string {
      if (this.availability.node.start) {
        const start = parseISO(this.availability.node.start);
        const end = parseISO(this.availability.node.end);

        if (start.getDay() === end.getDay()) {
          return `${format(start, 'h:mm aaa')} - ${format(end, 'h:mm aaa')}`;
        }
        return `${format(start, 'h:mm aaa')} - ${format(end, 'h:mm aaa (eee)')}`;
      }

      return DEFAULT_BODY;
    },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #f0f1f1;
  border-left: 4px solid theme('colors.success.DEFAULT');
  border-radius: 4px;
  background: var(--Surface-Foreground, #fff);
  /* +3 elevation */
  box-shadow: 0px 2px 4px 0px rgba(5, 7, 15, 0.16);

  &--available {
    border-left: 4px solid theme('colors.success.DEFAULT');
  }

  &--booked {
    border-left: 4px solid #76787e;

    .tile__heading {
      font-weight: normal;
    }
  }

  &__body {
    color: #282930;
    font-size: 0.875rem;
  }

  &__group {
    flex: 2;
  }

  &__heading {
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  &__action {
    flex: 1;
  }
}
</style>
